/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { InputField } from "../../molecules";
import { ModalWrapper } from "../../../common/modals/ModalWrapper";
import { ICategory59983, ICategory59983Input } from "../../../common/types";
import { Alert, Button, Divider, Form, InputFormWrapper } from "../../atoms";
import {
  addCategory59983ToFirestore,
  updateCategory59983InFirestore,
} from "../../../firestore/firestoreService";
import { closeModal } from "../../../redux/data/modals/modalReducer";

interface IProps {
  record?: ICategory59983;
  title: string;
}
export const AddCategoryModal: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const handleSubmit = async () => {
    try {
      const values: ICategory59983Input = await form.validateFields();
      setLoading(true);
      if (props.record) {
        await updateCategory59983InFirestore(props.record.id, {
          name: values.name,
          status: true,
        });
      } else {
        await addCategory59983ToFirestore({
          name: values.name,
          status: true,
        });
      }

      setLoading(false);
      dispatch(closeModal());
    } catch (errorInfo) {
      setLoading(false);
      if (typeof errorInfo === "string") {
        setError(errorInfo.toUpperCase());
      } else if (errorInfo instanceof Error) {
        setError(errorInfo.message);
      }
    }
  };
  return (
    <ModalWrapper {...props} footer={null}>
      <InputFormWrapper>
        <div className="input-form-body">
          {error !== "" && <Alert message={error} type="error" />}
          <Form
            form={form}
            name="horizontal_login"
            layout="vertical"
            autoComplete="off"
            initialValues={props.record || {}}
          >
            <InputField
              label="Name"
              name="name"
              rules={[{ required: true, message: "Missing Category Name" }]}
              placeholder="Category Name"
            />
            <Divider></Divider>
            <Button
              type="primary"
              className="input-form-btn"
              onClick={handleSubmit}
              loading={loading}
            >
              {props.title}
            </Button>
          </Form>
        </div>
      </InputFormWrapper>
    </ModalWrapper>
  );
};
